import { RouteConfig } from 'types/RouteConfig';

export const PrivateRouteConfig: Record<string, RouteConfig> = {
  TANK_MONITORS: {
    path: 'tank_monitors',
  },
};
